/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".image-upload__blurb[_ngcontent-%COMP%]{padding-bottom:15px}.image-upload__image-choice[_ngcontent-%COMP%]{padding-right:20px;padding-top:10px}.image-upload__selected-file[_ngcontent-%COMP%]{padding-left:20px}.image-upload__upload-progress[_ngcontent-%COMP%]{padding-left:46px}.image-upload__completed-files[_ngcontent-%COMP%]{height:100px}.image-upload__completed-file[_ngcontent-%COMP%]{padding-top:5px}p[_ngcontent-%COMP%]{padding-top:12px}"];
export { styles as styles };
